module.exports = __webpack_public_path__ + "static/media/drinks_menu.96709178.pdf";